import { render, staticRenderFns } from "./Doclib.vue?vue&type=template&id=5dacdad7&scoped=true"
import script from "./Doclib.vue?vue&type=script&lang=js"
export * from "./Doclib.vue?vue&type=script&lang=js"
import style0 from "./Doclib.vue?vue&type=style&index=0&id=5dacdad7&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dacdad7",
  null
  
)

export default component.exports